import styled from 'styled-components';
import { rem } from 'polished';
import isFavoriteCueStyles from '../../styles/isFavoriteCueStyles';

const ColorModalCustomHeader = styled.div`
    height: ${rem(240)};
    ${isFavoriteCueStyles}
`;

export default ColorModalCustomHeader;
